import { environment } from '@environments/environment';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class FindingCrudService {
    // eslint-disable-next-line
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.sendPositionSubject = new BehaviorSubject([]);
        this.sendPositioObservable = this.sendPositionSubject.asObservable();
    }
    updateObservation(dataForm) {
        return this.httpClient.put(environment.api.base + 'icrs/observations', dataForm);
    }
    createObservation(dataForm, analysisId) {
        dataForm.analysisId = analysisId;
        return this.httpClient.post(environment.api.base + 'icrs/observations?id=' + analysisId, dataForm);
    }
    deleteObservation(crObservationId) {
        return this.httpClient.delete(environment.api.base + 'icrs/observations/' + crObservationId);
    }
    deleteObservationList(arrayFindings) {
        return this.httpClient.request('delete', environment.api.base + 'icrs/observations/list', {
            body: arrayFindings,
        });
    }
    setPostion(pos) {
        this.sendPositionSubject.next(pos);
    }
    getPostion() {
        return this.sendPositioObservable;
    }
    UpdateObservationList(dataFinding) {
        return this.httpClient.put(environment.api.base + 'icrs/observations/list', dataFinding);
    }
    sendNotifications(analysisId) {
        return this.httpClient.put(environment.api.base + 'icrs/InternalReview?analysisId=' + analysisId, {});
    }
    UpdateActionPlan(analysisId, FechaFin) {
        return this.httpClient.put(environment.api.base +
            'icrs/UpdateActionPlan?analysisId=' +
            analysisId +
            '&FechaFin=' +
            FechaFin, {});
    }
}
FindingCrudService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FindingCrudService_Factory() { return new FindingCrudService(i0.ɵɵinject(i1.HttpClient)); }, token: FindingCrudService, providedIn: "root" });
